jQuery(function($){

	if(isRehearsalPage()) {
		let defaults = $('input#rehearsal-defaults').val();
		defaults = JSON.parse(atob(defaults));

		//Day of the week => Date
		if(defaults.hasOwnProperty('day_of_week')) {
			let nextRehearsalDate;

			let rehearsalDatesInputExists = $('input#scheduled-rehearsal-dates').length;
			let rehearsalDates = [];

			if($('input#scheduled-rehearsal-dates').length) {
				rehearsalDates = $('input#scheduled-rehearsal-dates').val();
				rehearsalDates = JSON.parse(atob(rehearsalDates));
			}

			if(rehearsalDates.length) {
				let dateStr = rehearsalDates[0];
				let date;
				let i = 0;
				while(i < rehearsalDates.length) {
					date = dateStr ? new Date(dateStr) : new Date();

					//Adjust for timezone
					date.setMinutes(date.getMinutes() + date.getTimezoneOffset());

					let excludeToday = dateStr == false ? false : true;
					
					nextRehearsalDate = getNextDayOfTheWeek(defaults.day_of_week, excludeToday, date);

					dateStr = formatDate(nextRehearsalDate, '-');
					i++;
				}
			} else {
				nextRehearsalDate = getNextDayOfTheWeek(defaults.day_of_week, false);
			}

			$('input.date.datepicker').val(formatDate(nextRehearsalDate, '-'));
			$('input.date.datepicker-value').val(formatDate(nextRehearsalDate, ''));
	
			//Title
			if(!defaults.hasOwnProperty('title_format')) defaults.title_format = 'Rehearsal {{date}}';
			let dateFormatted = formatDate(nextRehearsalDate, '/', 'frontend');
			let title = defaults.title_format.replaceAll(/{{date}}/ig, dateFormatted);

			$('input#title').val(title);
			$('#title-prompt-text').html('');

			//Date Field
			$('input.date.datepicker').val(formatDate(nextRehearsalDate, '-'));
			$('input.date.datepicker-value').val(formatDate(nextRehearsalDate, ''));


			$('.sc-field-editor').on('change', '.field.datepicker input.date.datepicker-value', function(){
				let value = $(this).val();
				let datepickerDate = new Date(value.slice(0,4), value.slice(4,6) - 1, value.slice(6,8));

				let eventType;
				if($('.sc-field-editor .field select[name="sc-fields[type]"]').length){
					$('.sc-field-editor .field select[name="sc-fields[type]"]').each(function(){
						eventType = $(this).val();
					});
					if(eventType == 'rehearsal') {
						title = defaults.title_format.replaceAll(/{{date}}/ig, formatDate(datepickerDate, '/', 'frontend'));
						$('input[name="post_title"]').val(title);
					}
				}
			});
		}

		//Event Type
		$('select.type').val('rehearsal');

		//Public Event
		if(defaults.hasOwnProperty('public')) $('select.public').val(defaults.public);
		if(defaults.hasOwnProperty('tentative')) $('select.tentative').val(defaults.tentative);

		let typeaheads = [
			'time',
			'end_time',
			'venue',
		];

		$.each(typeaheads, function(index, value){
			if(defaults.hasOwnProperty(value)) {
				clickSelectedResult(defaults[value], $('input.' + value + '.typeahead-value'));
			}
		});
	}

	function isRehearsalPage() {
		let currentPage = new URL(window.location.href);
		let rehearsalParam = currentPage.searchParams.get('co-rehearsal') !== null && currentPage.searchParams.get('co-rehearsal') === 'true';

		return $('input#rehearsal-defaults').length && rehearsalParam;
	}

	function clickSelectedResult(result, hiddenInput) {
		let parentDiv = hiddenInput.closest('.input-wrapper');
		parentDiv.addClass('hidden-values');
		let visibleInput = parentDiv.find('.typeahead-input');

		console.log(parentDiv)

		let i = 0;
		let hasValue = setInterval(function(){
			i++;

			let results = parentDiv.find('.results .result');

			console.log(i, results);
			if(results.length) {
				results.each(function(){
					if($(this).attr('post_id') == result) {
						$(this).click();
					}
				});
			} else {
				visibleInput.focus();
			}

			if(i >= 5 || results.length) {
				visibleInput.blur();
				clearInterval(hasValue);
				parentDiv.removeClass('hidden-values');
			}
		}, 500);
	}

	function getNextDayOfTheWeek(dayName, excludeToday = true, refDate = new Date()) {
		if(!refDate) return false;
		
		const dayOfWeek = ["sun","mon","tue","wed","thu","fri","sat"].indexOf(dayName.slice(0,3).toLowerCase());

		if(dayOfWeek < 0) return;
		refDate.setHours(0,0,0,0);
		refDate.setDate(refDate.getDate() + +!!excludeToday + (dayOfWeek + 7 - refDate.getDay() - +!!excludeToday) % 7);
		return refDate;
	}

	function formatDate(date, connector, displayType) {
		if(displayType === undefined) displayType = 'backend';

	    var d = new Date(date),
	        month = '' + (d.getMonth() + 1),
	        day = '' + d.getDate(),
	        year = d.getFullYear();

	    if(displayType != 'frontend') {
		    if (month.length < 2) month = '0' + month;
		    if (day.length < 2) day = '0' + day;
	    }

	    let dateArray = displayType == 'frontend' ? [month, day, year] : [year, month, day];
	    return dateArray.join(connector);
	}
});